import { useContext } from 'react';
import LibraryContext from '@contexts/LibraryContext';

function useLibrary() {
  return useContext(LibraryContext);
}

export default useLibrary;
